import ClientsAxios from '../client-axios';
import { ResponseEntity, LoginResponse, AuthUserState } from '../dto/response';
import { UserManager, WebStorageStateStore } from 'oidc-client';
import { Navigate, useNavigate } from 'react-router-dom';
import { IDENTITY_CONFIG, METADATA_OIDC } from '../../config/oidc.config';
import { encryptText, decryptText } from '../utils';
import { setAuthUser } from '../../redux/reducer/authUserSlice';
import { useDispatch } from 'react-redux';
import store from '../../redux/store';
import { showSnackbar } from '../../redux/reducer/snackbarSlice';
import { getAllPermissionsRoutes, handleMakingNestedData } from '../../Permissions/PermissionsOnRouteChange';
import { staticPermissionEmployeeRole } from '../../Permissions/constantJson';
import { NAVIGATE_RECRUITMENT, ERROR, NAVIGATE_DASHBOARD, NAVIGATE_ATTENDANCE, NAVIGATE_POLICY, NAVIGATE_SETTING, NAVIGATE_MYTEAM, NAVIGATE_EMPLOYEE } from '../../routes/ConstantRoutes';import { responseDataPermissionUsingRole } from '../../Permissions/constantJson';

import { staticPermissionEmployeeRole_UAT } from '../../Permissions/constantJson_UAT';
import { getUserUnreadAnnouncementListService } from './announcement/announcement.service';
import { openDialog } from '../../redux/reducer/dialogSlice';


const { RECRUITMENT_BASE_URL, EMPLOYEE_BASE_URL } = ClientsAxios;
// const { BASE_URL } = ClientsAxios;


export const userManager = new UserManager({
    ...(IDENTITY_CONFIG),
    metadata: { ...METADATA_OIDC },
    userStore: new WebStorageStateStore({ store: localStorage })
});

export class OIDCService {
    navigate = useNavigate();
    dispatch = useDispatch();
    signinRedirectCallback = async () => {
        // window.history.replaceState({},
        //     window.document.title,
        //     window.location.origin + window.location.pathname);
        const data: any = await userManager.signinRedirectCallback();
        await this.getUserDetails(data.access_token)

    }

    getUser = async () => {
        const user = await userManager.getUser()
        if (user) return user
        return await userManager.signinRedirectCallback()
    }

    parseJwt = (token: string) => {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/')
        return JSON.parse(window.atob(base64))
    }

    signinRedirect = () => {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('redirectUri', window.location.pathname)
        }
        userManager.signinRedirect({})
    }

    isAuthenticated = async () => {
        try {
            const user = await this.getUser();
            if (user) {
              if (!localStorage.getItem('user')) await this.getUserDetails(user.access_token);
            }
            return !!user;
        } catch (error: any) {
            return false;
        }
    }

    isTokenExpired = async () => {
        try {
            const user = await this.getUser();
            return user ? user.expired : true;
        } catch (error: any) {
            return true;
        }
    }

    getExpiryTime = () => { }

    signinSilent = () => {
        userManager.signinSilent().then((user: any) => {
        }).catch((err: any) => {
            console.log(err)
        });
    }

    signinSilentCallback = () => {
        userManager.signinSilentCallback()
    }

    createSigninRequest = () => {
        return userManager.createSigninRequest()
    }

    logout = async () => {
        const user = await this.getUser();
        userManager.signoutRedirect({
            id_token_hint: user.id_token
        });
        userManager.clearStaleState();
        localStorage.clear();
    }

    signoutRedirectCallback = () => {
        userManager.signoutRedirectCallback().then(() => {
            localStorage.clear()
            window.location.replace(IDENTITY_CONFIG.post_logout_redirect_uri)
        })
        userManager.clearStaleState()
    }

    navigateToScreen = () => {
        this.navigate(NAVIGATE_DASHBOARD.DASHBOARD_PAGE)
    }

    
    getUserDetails = async (oidcResponse: any): Promise<void> => {
        try {
          const { code, data } = await loginService(oidcResponse);
          if (code === 200 && data && Object.keys(data)?.length > 0 ) {
            const res: AuthUserState = { user: data, token: oidcResponse };
      
            const encrypted = JSON.stringify(res);
            localStorage.setItem('user', encryptText(encrypted));
            this.dispatch(setAuthUser(res));
      
            const redirecturl = localStorage.getItem("redirecturl");
      
            // Step 1: Try to get dynamic permissions
            console.log("before getPermissionsService api call");
            const responseEntity = await getPermissionsService(this.dispatch);
      
            if (responseEntity?.code === 200 && responseEntity?.data?.user_role_permission?.length > 0) {
              // If successful permissions are fetched, try redirecting
              if (handleCustomRedirect(this.dispatch, this.navigate, res)) return;
      
              console.log("after getPermissionsService api call");
              if (redirecturl) {
                localStorage.removeItem("redirecturl");
                this.navigate(redirecturl);
              } else {
                
                const moduleUrlsArray = getAllPermissionsRoutes(this.dispatch);   
                if(moduleUrlsArray?.includes(NAVIGATE_ATTENDANCE.ATTENDANCE)){
                  this.navigate(NAVIGATE_ATTENDANCE.ATTENDANCE) 
                }else{
                  this.navigate(NAVIGATE_RECRUITMENT.JOB.JOB_LIST_PAGE)
                }

              }
            } else {
              // Fallback to static permissions if API fails
              console.warn("Using fallback static permissions");
              const userDetails = store.getState().authUser ?? {};
              let constant_employee: any = process.env.REACT_APP_IS_LIVE === '1'
                ? staticPermissionEmployeeRole?.employee
                : staticPermissionEmployeeRole_UAT?.employee;
      
              const _data = constant_employee ?? {};
              localStorage.setItem('roles_permissions', encryptText(JSON.stringify(_data)));
      
              handleMakingNestedData(this.dispatch);
              getAllPermissionsRoutes(this.dispatch);
      
              if (redirecturl) {
                localStorage.removeItem("redirecturl");
                this.navigate(redirecturl);
              } else {

                const moduleUrlsArray = getAllPermissionsRoutes(this.dispatch);   
                if(moduleUrlsArray?.includes(NAVIGATE_ATTENDANCE.ATTENDANCE)){
                  this.navigate(NAVIGATE_ATTENDANCE.ATTENDANCE) 
                }else{
                  this.navigate(NAVIGATE_RECRUITMENT.JOB.JOB_LIST_PAGE)
                }

              }
            }
      
            // // Step 2: Fetch unread announcements
            try {
              const { code: announcementCode, data: announcementData } = await getUserUnreadAnnouncementListService({
                limit: 10,
                offset: 0,
              });
      
              if (announcementCode === 200 && announcementData?.announcements?.length) {
                this.dispatch(openDialog({
                  type: "UserAnnouncementDialog",
                  title: "Announcements",
                }));
              }
            } catch (error) {
              console.error("Error fetching announcements", error);
            }
      
          } else if (code === 404) {
            this.navigate(ERROR.USERNOTFOUND);
          } else {
            this.navigate(ERROR.ERROR_403_PAGE);
          }
        } catch (err) {
          console.error("getUserDetails failed:", err);
          this.navigate(ERROR.ERROR_403_PAGE);
        }
      };
      
   

    changePassword = async () => {
        window.open(IDENTITY_CONFIG.authority + '/Account/ChangePassword' + decryptText(localStorage.getItem('url')), '_self');
    }
}

export const loginService = async (token: string) => {
    const responseEntity = new ResponseEntity<LoginResponse>()
    try {
        const response = await EMPLOYEE_BASE_URL.post('employee-details', {}, {
            headers: {
                authorization: token
            }
        })
        responseEntity.success(response.data.body, 200, response.data.Message)
    } catch (error: any) {
        const response = error.response || {};
        console.log("response.statusCode",response)
        responseEntity.error(response.status || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}
type ModuleItem = {
    uuid: string;
    parent_id: string;
    name: string;
    slug: string;
    module_url: string;
    icon: string;
    module_order: string;
    is_navigation: number;
    operations: string[];
  };
  
  const getMergeKey = (item: ModuleItem): string => {
    return item.module_url && item.module_url.trim() !== ''
      ? item.module_url.trim()
      : item.slug;
  };
  
  //it will merge by module_url and if module_url is empty it will do by slug
  const mergedByModuleUrlOrSlug = (A: ModuleItem[], B: ModuleItem[]): ModuleItem[] => {
    const aMap = new Map<string, ModuleItem>(
      A.map(item => [getMergeKey(item), { ...item }])
    );
  
    B.forEach(itemB => {
      const key = getMergeKey(itemB);
      const existing = aMap.get(key);
  
      if (existing) {
        const mergedOps = Array.from(new Set([
          ...(existing.operations || []),
          ...(itemB.operations || [])
        ]));
        existing.operations = mergedOps;
      } else {
        aMap.set(key, itemB);
      }
    });
  
    return Array.from(aMap.values());
  };
  
  
  
export const getPermissionsService = async (dispatch: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await EMPLOYEE_BASE_URL.post('iam/permission');
        responseEntity.success(response.data.body, 200, response.data.Message);
        const { code, data } = responseEntity;
        if (code === 200 && data && data?.user_role_permission?.length > 0) {
        
            console.log(" code === 200  getPermissionsService and processing start ........")
           
              let constant_user_role_permission:any = [] ;
              if(process.env.REACT_APP_IS_LIVE === '1' ){
                 constant_user_role_permission = staticPermissionEmployeeRole?.employee?.user_role_permission;
              }else{
                 constant_user_role_permission = staticPermissionEmployeeRole_UAT?.employee?.user_role_permission;
              }

              const merged = mergedByModuleUrlOrSlug(constant_user_role_permission, data?.user_role_permission);
              const jsonSONStringify = JSON.stringify({...data,user_role_permission:merged});

            localStorage.setItem('roles_permissions', encryptText(jsonSONStringify));
            const user_role_permission: any = data?.user_role_permission ?? [];
            handleMakingNestedData(dispatch);
            getAllPermissionsRoutes(dispatch);
            console.log(" code === 200  getPermissionsService and processing done ........")
        } else {
              console.log("in Fail case")
                            // Fail case
                            const userDetails: any = store.getState().authUser ?? {};
                            // let _data = responseDataPermissionUsingRole[userDetails?.user?.user_role]?? {};

                           let constant_employee:any = {} ;
                           if(process.env.REACT_APP_IS_LIVE === '1'){
                            constant_employee = staticPermissionEmployeeRole?.employee;
                           }else{
                            constant_employee = staticPermissionEmployeeRole_UAT?.employee;
                           }


                            let _data = constant_employee ?? {};
                            const jsonSONStringify = JSON.stringify(_data);
                            localStorage.setItem('roles_permissions', encryptText(jsonSONStringify));
                            const user_role_permission: any = _data?.user_role_permission ?? [];
                            handleMakingNestedData(dispatch);
                            getAllPermissionsRoutes(dispatch);
            dispatch(showSnackbar({ message: "Please contact the support team for permissions.", type: "error", open: true }));
        }
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}



export const handleCustomRedirect = (dispatch: any,navigate :any, loginUserDetails: any) => {
    let isCustomRedirect: boolean = false;
    const moduleUrlsArray = getAllPermissionsRoutes(dispatch);   //    //allAccessRoutesArray
    const user: any = loginUserDetails?.user ?? {};
    const location = { pathname: window.location.pathname };
        

    const isUserProfilePending = (user: any, moduleUrlsArray: any, location: any): boolean => {
        return (
          user?.policy_acknowledgement_status === "read" &&
          user?.asset_acknowledgement_status === "Y" &&
          moduleUrlsArray?.includes(NAVIGATE_SETTING.USERPROFILE_SETTING_PAGE) &&
          location?.pathname !== NAVIGATE_SETTING.USERPROFILE_SETTING_PAGE &&
          ["family_details_pending", "address_details_pending", "education_details_pending", "emergency_contact_details_pending"]
            .some(key => user?.[key] === "Y")
        );
      };
      

    if (user?.policy_acknowledgement_status !== "read" || user?.asset_acknowledgement_status !== "Y" || user?.family_details_pending === "Y" || user?.probation_status_pending === "Y" || user?.address_details_pending === "Y" || user?.education_details_pending === "Y" || user?.emergency_contact_details_pending === "Y" ) {
        if (moduleUrlsArray?.includes(NAVIGATE_POLICY.POLICIES) && user.hasOwnProperty("policy_acknowledgement_status") && user?.policy_acknowledgement_status !== "read" && location?.pathname !== NAVIGATE_POLICY.POLICIES) {
            isCustomRedirect = true;
            navigate(NAVIGATE_POLICY.POLICIES);
        } 
        else if (user?.policy_acknowledgement_status === "read" && moduleUrlsArray?.includes(NAVIGATE_EMPLOYEE.ASSETS_PAGE) && user.hasOwnProperty("asset_acknowledgement_status") && user?.asset_acknowledgement_status !== "Y" && location?.pathname !== NAVIGATE_EMPLOYEE.ASSETS_PAGE) {
            isCustomRedirect = true;            
            navigate(NAVIGATE_EMPLOYEE.ASSETS_PAGE);
        } 
        else if (isUserProfilePending(user,moduleUrlsArray,location)) {
            isCustomRedirect = true;
            navigate(NAVIGATE_SETTING.USERPROFILE_SETTING_PAGE);
        } else if (user?.family_details_pending !== "Y" && user?.policy_acknowledgement_status === "read" && moduleUrlsArray?.includes(NAVIGATE_MYTEAM.MYTEAM) && user.hasOwnProperty("probation_status_pending") && user?.probation_status_pending === "Y" && location?.pathname !== NAVIGATE_MYTEAM.MYTEAM) {
            isCustomRedirect = true;
            navigate(NAVIGATE_MYTEAM.MYTEAM);
        }
        // else if (user?.announcement_read_pending !== "Y" && user?.family_details_pending !== "Y" && user?.policy_acknowledgement_status === "read" && moduleUrlsArray?.includes(NAVIGATE_MYTEAM.MYTEAM) && user.hasOwnProperty("probation_status_pending") && user?.probation_status_pending === "Y" && location?.pathname !== NAVIGATE_MYTEAM.MYTEAM) {
          // window.open(NAVIGATE_MYTEAM.MYTEAM, "_self");
          // open Dialog
           // this.dispatch(openDialog({
            //     type: "UserAnnouncementDialog",
            //     title: "Announcements",
            //   }));
      // }
    }

    return isCustomRedirect;
}